<template lang="html">

  <div class="wrapper -observatorio">

    <div class="encabezado">
      <div class="container column-start">
        <div class="contenedor-logo">
          <img src="/static/img/UFV-logo.png" alt="Logo UFV">
        </div>
        <h1>Observatorio de empleo</h1>
      </div>
    </div>


    
    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.observatorio')">Observatorio</router-link>
        </nav>
      </div>
    </div>

    <section class="proyecto-formativo -observatorio">
      <div class="container column-center">
        <h2 class="big-bold-title">Observatorio de empleo</h2>
        <p>El Observatorio de Empleo es un Proyecto estratégico del Departamento de Carreras Profesionales UFV, cuyo objetivo principal es contar con un centro de recogida de datos sobre las características más notables de la inserción laboral de nuestros titulados universitarios, y, así <strong>facilitar a la comunidad universitaria información actualizada, fiable y útil para la toma de decisiones.</strong></p>
    

      </div>
    </section>

    <destacados :position="'6'" :withouttitle="true"></destacados>



    <section class="barometro" id="barometro">

      <div class="container">

        <img src="/static/img/imagen-barometro.png" alt="">

        <p>Anualmente se elabora este estudio que tiene como objetivo establecer el grado de inserción laboral de los
          alumnos graduados de la Universidad Francisco de Vitoria, conociendo las características de la empresa en la
          que trabajan y sus condiciones laborales, el tiempo que han tardado en encontrar empleo, las características
          de su perfil que han propiciado su empleabilidad y las causas por las que no están trabajando quienes no lo
          hacen en el momento de elaborar el estudio.</p>

        <div class="buscadores row-between">
          <div class="contenedor-select">
            <label for="">Nivel de estudios</label>

            <multiselect v-model="filter.grado" :options="grados" :searchable="true" :close-on-select="false"
              :show-labels="false" :closeOnSelect="true" :multiple="false" :track-by="'name'" :value="'slug'"
              :label="'name'" placeholder="Seleccione uno"></multiselect>
          </div>
          <div class="contenedor-select">
            <label for="">Promoción</label>
            <select name="" id="" v-model="filter.promocion">
              <option value="">Seleccione un año de promoción</option>
              <option v-for="year in anyos" :value="year">{{year}} - {{year+1}}</option>
            </select>
          </div>
         <!-- <div class="contenedor-select">
            <label for="">Tipo de informe</label>
            <select name="" id="" v-model="filter.tipo">
              <option value="">Seleccione tipos de informe</option>
              <option value="1">Primer Barómetro de empleabilidad</option>
              <option value="2">Segundo Barómetro de empleabilidad</option>
              <option value="3">Primer informe ejecutivo</option>
              <option value="4">Segundo informe ejecutivo</option>
              <option value="0">Otros</option>
            </select>
          </div>-->
        </div>

      </div>

      <div class="eventos-barometro">

        <div class="container row-start ais">

          <template v-if="ficheros.length == data.length">

            <h3 class="subtitle -observatorio">Observatorio de empleo</h3>
            <fichero :doc="doc" :key="'barometro'+key" v-for="(doc,key) in ficherosbarometro.slice((perpage*paginators.barometro)-perpage,perpage*paginators.barometro)"></fichero>
            <div class="contenedor-paginador row-center">
              <a @click="prev('barometro')" class="prev"></a>
              <a :active="n == paginators.barometro" @click="setPage('barometro',n)" v-for="n in pages.barometro">{{n}}</a>
              <a @click="next('barometro')" class="next"></a>
            </div>

            <template v-if="ficherosotro.length != 0">
            <h3 class="subtitle">Otros informes</h3>
              <fichero  :doc="doc" :key="'otros'+key" v-for="(doc,key) in ficherosotro.slice((perpage*paginators.otros)-perpage,perpage*paginators.otros)"></fichero>
              <div class="contenedor-paginador row-center" v-if="pages.otros > 1">
                <a @click="prev('otros')" class="prev"></a>
                <a :active="n == paginators.otros" @click="setPage('otros',n)" v-for="n in pages.otros">{{n}}</a>
                <a @click="next('otros')" class="next"></a>
              </div>
            </template>

          </template>

          <template v-else>

            <fichero :doc="doc" :key="'ficheros'+key" v-for="(doc,key) in ficheros.slice((perpage*paginators.ficheros)-perpage,perpage*paginators.ficheros)"></fichero>
            <div class="contenedor-paginador row-center" v-if="pages.ficheros > 1">
              <a @click="prev('ficheros')" class="prev"></a>
              <a :active="n == paginators.ficheros" @click="setPage('ficheros',n)" v-for="n in pages.ficheros">{{n}}</a>
              <a @click="next('ficheros')" class="next"></a>
            </div>

          </template>

          <p v-if="ficheros.length == 0">No se han encontrado resultados</p>
         
        </div>




      </div>



    </section>




  </div>

</template>

<script lang="js">

  import bannerconectados from '@/components/parts/banner-conectados';
  import aldiabanner from '@/components/parts/al-dia-banner';

  import aldia from '@/components/view-parts/home/al-dia';

  import destacados from '@/components/parts/destacados';

  import fichero from '@/components/parts/fichero';

  import Multiselect from 'vue-multiselect'

  import { mapActions } from 'vuex';

  export default {
    name: 'observatorio',
    mounted() {
      this.getdata();
      console.log("Hola");
    },
    data() {
      return {
        showproyectoformativo: false,
        showempleo: false,
        data: [],
        perpage : 6,
        filter: {
          grado: '',
          promocion: '',
          tipo: ''
        },
        paginators :  {
          barometro : 1,
          otros : 1,
          ficheros : 1
        }
      }
    },
    components: {
      'banner-conectados': bannerconectados,
      'al-dia-banner': aldiabanner,
      'al-dia': aldia,
      'destacados': destacados,
      'fichero' : fichero,
      Multiselect
    },
    computed: {
      ficheros() {

        let ficheros;

        if (!!this.data) {
          ficheros = this.data.slice();
          
          if (!!this.filter.tipo) {
            ficheros = ficheros.filter(f => f.type.toString() == this.filter.tipo);
          }

          if (!!this.filter.grado) {
            ficheros = ficheros.filter(f => f.category.slug == this.filter.grado.slug);
          }

          
          if (!!this.filter.promocion) {
            ficheros = ficheros.filter(f => f.year == this.filter.promocion);
          }
          
        }

        return ficheros;
      },
      ficherosbarometro(){
        let data = new Array();
        if(!!this.data){
          data = this.data.filter(e => e.type != 0);
        }
        return data;
      },
      ficherosotro(){
        let data = new Array();
        if(!!this.data){
          data = this.data.filter(e => e.type == 0);
        }
        return data;
      },
      pages(){
    
        let data = {}

        data.ficheros = Math.ceil(this.ficheros.length/this.perpage);
        data.barometro = Math.ceil(this.ficherosbarometro.length/this.perpage);
        data.otros = Math.ceil(this.ficherosotro.length/this.perpage);

        return data;

      },
      anyos() {
        let years = new Array();
        if (!!this.data) {
          this.data.forEach(e => {
            if (!years.some(y => y == e.year)) {
              years.push(e.year);
            }
          })
        }

        return years.sort();

      },
      grados() {
        let grados = new Array();
        if (!!this.data) {
          this.data.forEach(e => {
            if (!grados.some(g => g.slug == e.category.slug)) {
              grados.push(e.category);
            }
          })
        }

        return grados;

      }
    },
    methods: {
      ...mapActions(['requestBarometro', 'requestDoc', 'requestOtros']),
      getdata() {
        this.requestBarometro().then(r => {
          this.data = this.data.concat(r);
        })
        this.requestOtros().then(r => {
          this.data = this.data.concat(r);
        })
      },
      prev(where){
        if(this.paginators[where]> 1){
          this.paginators[where]--;
        }
      },
      next(where){
        if(this.paginators[where]< this.pages[where]){
          this.paginators[where]++;
        }
      },
      setPage(where,page){
        this.paginators[where] = page;
      }
    },

  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/observatorio.vue